<script>
  import Footer from '../landing_page/footer.svelte';
  import {blockchain} from './program_data.js';
  import HeaderProgramSection from './header_program_section.svelte';
  import SpeakerSlider from './mobile_reuse-section/speaker_slider.svelte';
  import {speakerSectionBlockchain} from './mobile_reuse-section/mobile_reuse_section_data.js';
  import ThankYou from '../thankyou_popup/thanku.svelte';
  import {showThankUPopUp} from './store.js';
  const {title} = rpcjs.props;
  title.set('Blockchain | Accelerators');
  const people = [
      {
          img: 'images/blockchain_page/speakers/adam_draper.png',
          name: 'Adam Draper',
          about: 'Boost VC',
      },
      {
          img: 'images/blockchain_page/speakers/bruno_faviero.jpg',
          name: 'Bruno Faviero',
          about: 'Magna',
      },
      {
          name: 'Jason Lee',
          about: 'Algorand',
          img: 'images/blockchain_page/speakers/jason_lee.jpg',
      },
      {
          name: 'Mike Arrington',
          about: 'Arrington Capital',
          img: 'images/blockchain_page/speakers/mike_arrington.png',
      },
      {
          name: 'Shiv Sakhuja',
          about: 'Magik Invest',
          img: 'images/blockchain_page/speakers/shiv_sakhuja.jpg',
      },
      {
          name: 'Marcelo Cavazzoli',
          about: 'Lemon Cash',
          img: 'images/blockchain_page/speakers/marcelo_cavazzoli.jpeg',
      },
      {
          name: 'Travis Wu',
          about: 'lumièreVR',
          img: 'images/blockchain_page/speakers/travis_wu.jpg',
      },
      {
          name: 'Emmie Chang',
          about: 'Hoo',
          img: 'images/blockchain_page/speakers/emmie_chang.jpg',
      },
      {
          name: 'Sunny Lu',
          about: 'VeChain',
          img: 'images/blockchain_page/speakers/sunny_lu.jpg',
      },
  ];

  const strategy = [
      {
          count: 'i',
          detail:
        'Start and grow with us. Helping entrepreneurs is in our DNA we can help you as ' +
        ' you formulate your idea and validate your market through to capital for global scale.',
      },
      {
          count: 'ii',
          detail: 'Learn from Silicon Valley Experts',
      },
      {
          count: 'iii',
          detail:
        'We provide everything from the blockchain basics and entrepreneurial education to progressive ' +
        ' learning modules for the fastest growing companies on the planet.',
      },
      {
          count: 'iv',
          detail:
        'Network with major global Venture Capitalists and Crypto Investors',
      },
      {
          count: 'v',
          detail: 'Application or custom design process',
      },
      {
          count: 'vi',
          detail: 'Sourcing and Scouting companies from our portfolio and pipeline',
      },
      {
          count: 'vii',
          detail:
        'Global Awareness Campaign in conjunction with activating our Global Network; Draper Venture ' +
        ' Network (24 funds globally) and Draper Startup House’s ecosystem of international grassroots communities',
      },
      {
          count: 'viii',
          detail:
       'Network with major global Venture Capitalists and Crypto Investors',
      },
      {
          count: 'ix',
          detail: 'Several rounds of Due Diligence',
      },
      {
          count: 'x',
          detail: 'Teams selected and provided with seed capital',
      },
      {
          count: 'xi',
          detail: 'Accelerated bespoke cohort-based learning',
      },
      {
          count: 'xii',
          detail: 'Demo day with Global Venture Capitalists and Industry Partners',
      },
  ];
  let show = 'more...';
  let show1 = 'more...';
  let show2 = 'more...';

  let arrow;
  let content;
  let btnWidth;
  const formData = {
      name: '',
      email: '',
      msg: '',
  };
  // <!-- Google Tag Manager -->
  (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
  // <!-- End Google Tag Manager -->
  /**
   *
   *
   */
  function displayPopUp() {
      showThankUPopUp.update((n) => n + 1);
  }
  /**
   *
   *
   */
  async function SaveData() {
      const functionUrl =
      'https://us-central1-draper-university.cloudfunctions.net/sendEmail';
      await fetch(functionUrl, {
          method: 'POST',
          mode: 'cors',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              data: [
                  formData.email,
                  formData.name,
                  formData.msg,
                  'Request Customised Program',
              ],
          }),
      }).then(function(res) {
          if (res.status === 200) {
              displayPopUp();
          } else {
              alert('ERROR!', res);
          }
      });
  }
</script>

<HeaderProgramSection
  data={blockchain}
  widthDescription="66.516vw"
  lineHeightMbl="11.299vw"
  lineHeight="14.026vw"
  TopMbl="109vw"
  hrWidth="58.929vw"
  colors="white"
  boxTop="38.616vw"
  hrTop="-1.1vw"
  headingLeft="1.35vw"
  headingTop="-12vw"
  marginTop="0.2vw"
  discTop="36.3vw"
/>
<ThankYou />
<div class="desktop">
  <div style="width: 83.602vw;margin-top: 10.913vw;">
    <div style="display: flex;">
      <h1
        style="font-size:1.191vw;opacity: 0.3;margin-right: 4.828vw;margin-left:4.762vw;padding-top:1.3vw;"
      >
        01
      </h1>
      <h1
        style="font-size: 2.646vw;
      color: rgb(0, 32, 75);text-transform:uppercase;"
      >
        Alumni Sucess Stories
      </h1>
    </div>
  </div>
  <div style="display: flex;margin-top: 11.376vw;">
    <div style="position:relative">
      <div class="circle" />
      <div class="circle" />
      <div class="circle" />
    </div>
    <div style="margin-left: 32.5vw;position:relative;">
      <div
        style="width:  11.408vw;     margin-top: -5.3vw;margin-left: -0.6vw;"
      >
        <img src="images/alumni_success/Qtum.svg" alt="" width="100%" />
      </div>
      <div style="width: 9.193vw;margin-top: 8vw;margin-left: -1vw;">
        <img src="images/alumni_success/algorand.svg" alt="" width="100%" />
      </div>
      <div
        style="width: 9.854vw;
        margin-top: 8.45vw;  margin-left: -1vw;"
      >
        <img src="images/alumni_success/tezos.png" alt="" width="100%" />
      </div>
    </div>
    <div>
      <div
        style="width: 26.124vw;height:11vw; margin-left: 5vw;margin-top: -5vw;"
      >
        <p style="font-size:2.067vw; font-weight:500;margin-bottom:0.85vw;">
          QTUM
        </p>
        {#if show === 'more...'}
          <p style="font-size: 1.058vw;line-height:1.280vw;">
            110 executives from 56 industries came together for a 5 day program
            to explore the potential for innovation with
          </p>
        {:else if show === 'less...'}
          <p style="font-size: 1.058vw;line-height:1.280vw;">
            110 executives from 56 industries came together for a 5 day program
            to explore the potential for innovation with blockchain technologies
            and chart the future forward. Started by a DraperU alum, QTUM and
            Draper University both believe that industries and facets-of-life
            will be disrupted by blockchain technology, in the way that all
            industries and facets-of-life were disrupted by the internet.
          </p>
        {/if}

        <button
          style="border: none; color:#7CC1FF; font-size:1.323vw;    background-color: transparent;
        margin-left: 22vw;"
          on:click={() => {
            if (show === 'less...') {
              show = 'more...';
            } else {
              show = 'less...';
            }
          }}>{show}</button
        >
      </div>
      <div
        style="width: 26.124vw;height:11vw;    margin-left: 5vw;margin-top: 6.8vw;"
      >
        <p style="font-size:2.067vw; font-weight:500;margin-bottom:0.85vw;">
          Algorand Foundation
        </p>
        {#if show1 === 'more...'}
          <p style="font-size: 1.058vw;line-height:1.280vw;">
            $17.5M committed on Demo Day. Draper University in partnership with
            the Algorand Foundation and Borderless
          </p>
        {:else if show1 === 'less...'}
          <p style="font-size: 1.058vw;line-height:1.280vw;">
            $17.5M committed on Demo Day. Draper University in partnership with
            the Algorand Foundation and Borderless Capital, sourced, funded and
            accelerated 13 teams building on the Algorand blockchain. Over 10
            weeks the startups went through rigorous training, met with
            countless mentors, venture capitalists, and leading entrepreneurial
            facilitators while building and growing their Web3 businesses. In
            the end they presented LIVE to over 200 investors from across the
            globe that committed over $17.5M to the presenting teams.
          </p>
        {/if}

        <button
          on:click={() => {
            if (show1 === 'less...') {
              show1 = 'more...';
            } else {
              show1 = 'less...';
            }
          }}
          style="border: none; color:#7CC1FF; font-size:1.323vw;    background-color: transparent;
        margin-left: 22vw;">{show1}</button
        >
      </div>
      <div
        style="width: 26.124vw; height:11vw;   margin-left: 5vw;margin-top: 9.3vw;"
      >
        <p style="font-size:2.067vw; font-weight:500;margin-bottom:0.85vw;">
          Tezos Israel
        </p>
        {#if show2 === 'more...'}
          <p style="font-size: 1.058vw;line-height:1.280vw;">
            80 founders incubated over 2 programs. Tezos Israel and Draper
            University brought together talented advisors and
          </p>
        {:else if show2 === 'less...'}
          <p style="font-size: 1.058vw;line-height:1.280vw;">
            80 founders incubated over 2 programs. Tezos Israel and Draper
            University brought together talented advisors and experts from
            Silicon Valley to help mentor, guide and scale blockchain focused
            businesses across the globe. Excitingly, the potential of blockchain
            remains largely untapped, and the path forward to a more trusting
            and efficient future run on the blockchain is being paved
            minute-by-minute, as we partner with leading blockchains.
          </p>
        {/if}

        <button
          on:click={() => {
            if (show2 === 'less...') {
              show2 = 'more...';
            } else {
              show2 = 'less...';
            }
          }}
          style="border: none; color:#7CC1FF; font-size:1.323vw;    background-color: transparent;
        margin-left: 22vw;">{show2}</button
        >
      </div>
    </div>
  </div>
  <div class="speaker" style=" margin-top: 10.582vw;">
    <div style="display: flex;flex-wrap: wrap;width: 51vw; margin-left: 7vw;">
      {#each people as grid}
        <div class="speaker_box">
          <div class="text">
            <div
              style="width:8.532vw;height:8.532vw;border-radius:50%;margin:1vw auto; 0 auto;"
            >
              <img
                src={grid.img}
                alt=""
                width="100%"
                style="border-radius:50%; height:100%"
              />
            </div>
            <div
              style="margin-top:3vw;text-align:center;padding:1vw;background-color:#f4f4f4;"
            >
              <h1 style="font-size:1.190vw; font-weight:600">{grid.name}</h1>
              <h1 style="font-size: 0.926vw;">
                {grid.about}
              </h1>
            </div>
          </div>
        </div>
      {/each}
    </div>
    <div
      style="display: flex;margin-top: 11.5vw; margin-left:3.638vw;width:35vw;"
    >
      <h1
        class="section1"
        style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3; margin-top:0.85vw;"
      >
        02
      </h1>
      <div>
        <h1
          class="section-title"
          style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
        >
          Speakers Highlights
        </h1>
        <p
          style="font-size: 1.058vw; width: 24.140vw; color: #00204B; margin-top:1.587vw;    line-height: 1.280vw;"
        >
          Founders collaborate through moderated discussions and join the
          experts for live interviews with industry leaders, including Q&A. In
          addition, there are live office hours to facilitate the cohort.
        </p>
      </div>
    </div>
  </div>
  <div name="customisedProgram" style="display: flex; margin-top: 10vw;">
    <div style="display: flex;margin-top: 11vw; margin-left:4vw;width:35vw;">
      <h1
        class="section1"
        style="color:#00204B;font-size:1.191vw;margin-right:5vw; opacity:0.3; margin-top:0.85vw;"
      >
        03
      </h1>
      <div>
        <h1
          class="section-title"
          style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
        >
          Curriculum Highlights
        </h1>
        <p
          style="font-size: 1.058vw; width: 28.042vw; color: #00204B; margin-top:1.587vw;line-height: 1.280vw;"
        >
          Each program is custom designed based on the focus and growth
          objectives of our partners. We take a case-based approach featuring
          use cases from finance, healthcare, supply chain management, and
          consumer products.
        </p>
        <div
          on:click={() => {
            if (arrow.style.transform === 'rotate(0deg)') {
              arrow.style.transform = 'rotate(180deg)';
              btnWidth.style.width = '19.114vw';
              btnWidth.style.height = '18.519vw';
              btnWidth.style.textAlign = 'start';
              btnWidth.style.paddingLeft = '3.307vw';
              content.style.marginLeft = '-2.3vw';
              content.style.marginTop = '1.25vw';
              content.style.display = 'block';
            } else {
              arrow.style.transform = 'rotate(0deg)';
              btnWidth.style.width = '10.847vw';
              btnWidth.style.height = '3.638vw';
              btnWidth.style.textAlign = 'center';
              btnWidth.style.paddingLeft = '0vw';
              content.style.display = 'none';
            }
          }}
          bind:this={btnWidth}
          style="border: 0.066vw solid rgb(60, 116, 192);
          width: 10.847vw;
          height: 3.638vw;
          border-radius: 1.984vw;
          text-align: center;
          font-size: 0.926vw;
          color: rgb(0, 32, 75);
          padding-top: 1vw;
          background-color: transparent;
          margin-top: 2.7vw;
          cursor: pointer;"
        >
          Process
          <span>
            <img
              src="images/alumni_success/barrow.svg"
              bind:this={arrow}
              alt=""
              style="width: 0.6vw;margin-left:0.5vw;transform:rotate(0deg)"
            />
          </span>

          <div bind:this={content} style="display:none;">
            <ul style="width: 15.542vw;">
              <li>
                <p style="font-size:0.8vw;font-weight:bold;">Interview</p>
                <p style="font-size:0.7vw;">
                  Founders collaborate through moderated discussions and join
                  the experts for live interviews with industry leaders,
                  including Q&A. In addition, there are live office hours to
                  facilitate the cohort.
                </p>
              </li>
              <li style="margin-top: 0.7vw;">
                <p style="font-size:0.8vw;font-weight:bold;">Get Notified</p>
                <p style="font-size:0.7vw;">
                  After the interview, you will recieve an admissions decision
                  within 4-4 weeks. Financial Aid is awarded on a rolling basis,
                  so apply ASAP!
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="back-div" style="position: relative;">
      <div class="process-div">
        <h4 style="font-size:1.323vw; font-weight:600; color:#00204B;">
          Request Customised Program
        </h4>
        <p
          style="width: 25.595vw; font-size:0.926vw;color:#00204B;margin-top:1vw;line-height: 1.280vw;"
        >
          Our application is simple. Tell us your business idea (if you have
          one), and why you were put on this earth. Include what makes you
          unique!
        </p>
        <form on:submit|preventDefault={SaveData}>
          <input
            required
            class="input_desktop"
            style="margin-top: 3.241vw;"
            type="text"
            placeholder="Name..."
            bind:value={formData.name}
          />
          <input
            required
            class="input_desktop"
            style="margin-top: 0.661vw;"
            type="email"
            placeholder="E-mail..."
            bind:value={formData.email}
          />
          <textarea
            required
            class="textarea"
            col="20"
            rows="8"
            placeholder="Message"
            style="width: 27.447vw;  border-radius: 0.661vw;font-size: 0.926vw;
             padding-left: 1vw; padding-top: 1vw; margin-top: 1.124vw; background-color: rgb(240, 240, 240); border: 0.066vw solid rgb(121, 173, 244);color: rgb(139 139 139);"
            bind:value={formData.msg}
          />
          <button
            style="background-color: #3c74c0;border-radius: 1.984vw; color:white;font-size:0.926vw;
          border:none;width:18.651vw;height:3.638vw;margin-top: 1.623vw;margin-left: 4vw;"
            >Contact Bussiness Develeopment</button
          >
        </form>
      </div>
    </div>
  </div>
  <div style="position:relative;margin-top: 2.193vw;">
    <div style="width: 88.815vw;margin:auto;padding:0 1vw;height:33vw;">
      <div
        style="display: flex;align-items:center;justify-content: space-between;"
      >
        <div style="position: relative;">
          <div style="display:flex;align-items: center;margin-top: -3vw;">
            <h1
              style="color:rgba(0, 32, 75, 1);font-size:1.191vw;margin-right:1vw;opacity: 0.3;margin-top: 6.5vw;"
            >
              04
            </h1>
            <h1
              style="color: rgba(124, 193, 255, 0.2);font-size: 14.560vw;font-weight: bold;padding-top: 7vw;"
            >
              For...
            </h1>
          </div>

          <div
            style="    position: absolute;
              top: 13.7vw;
              left: 5.59vw;"
          >
            <div>
              <h1
                style="font-size:1.985vw;color:rgba(75, 154, 215, 1);text-transform: uppercase;"
              >
                Startup
              </h1>
              <div style="width:38.584vw;margin-top: 1.5vw;">
                <p style="font-size:1.191vw;    line-height: 1.280vw;">
                  Scale with leaders in blockchain acceleration. From Draper's
                  early investments in Coinbase and Bitcoin to Boost VC backing
                  Sci-Fi startups - We have believed in Web3 technology since
                  day one. Let us help you build the right foundation or scale
                  globally.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative;">
          <div
            style="width: 17.281vw;height: 26.34vw;position: absolute;top: -4vw;right: 11vw;"
          >
            <img
              src="/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png"
              alt=""
              width="100%"
            />
          </div>
          <div
            style="width: 16.222vw;position: absolute;height: 14.229vw;top: 16vw;right: 10.5vw;"
          >
            <img
              src="/images/corporative_section/Draper-startuphouse-startuptalky-1.png"
              alt=""
              width="100%"
            />
          </div>
          <div
            style="width: 18.34vw;height: 16.347vw;position: absolute;top: 7.7vw;right: -2vw"
          >
            <img
              src="/images/corporative_section/image-asset 2.png"
              alt=""
              width="100%"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="position:absolute;top: 24.5vw;left: 11.8vw;">
      <div>
        <h1
          style="font-size:1.985vw; color: #035BA0;text-transform: uppercase;"
        >
          Major Blockchain
        </h1>
        <div style="width:38.584vw;">
          <p
            style="font-size:1.191vw;line-height: 1.280vw;margin-top: 0.992vw;"
          >
            We have the right network, infrastructure, and track record to
            deliver a world-class accelerator program, from entrepreneurial
            education and facilities to mentors and venture capital.
          </p>
        </div>
      </div>
    </div>
    <div style="position:absolute;top: 33.8vw;left: 11.8vw;">
      <div>
        <h1
          style="font-size:1.985vw; color: #035BA0;text-transform: uppercase;"
        >
          Who Else?
        </h1>
        <div style="width:38.584vw;margin-bottom:2vw">
          <p
            style="font-size:1.191vw;line-height: 1.280vw;margin-top: 0.992vw;"
          >
            Meet, network and grow with other blockchain founders building
            products and services on chain. Meet and build relationships with
            world-leading mentors, investors and alumni that support you
            throughout the program.
          </p>
        </div>
        <div
          on:click={() => (location.href = '/applyProgram')}
          style="cursor:pointer"
        >
          <p
            style="margin: 0;color:#035BA0;font-size: 0.926vw;    font-weight: 600;"
          >
            APPLY NOW
          </p>
          <div style="width: 5.3vw;">
            <img
              src="/images/corporative_section/Line_282.svg"
              alt=""
              width="100%"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="position: relative;margin-top: 24.85vw;">
      <div class="top">
        <div class="hr" />
        <div class="hr1" />
        <h6
          style="color: white; font-size:3.390vw; font-weight:600;margin-top: 4.5vw;text-transform: uppercase;"
        >
          Fast-tracking your global innovation strategy
        </h6>
      </div>
    </div>
    <div
      style="    background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 88.35%);padding:1vw; position: relative;
      margin-top: 37.6vw; margin-bottom: -0.2vw;"
    >
      <div style="width: 88.815vw;margin:7vw auto 0vw;padding:0 1vw;">
        <div style="display: flex;align-items:center">
          <h1
            style="color:white;font-size:1.190vw;margin-right:5vw;opacity: 0.7;    margin-top: 0.6vw;"
          >
            05
          </h1>
          <h1 style="color:white;font-size:2.068vw;text-transform: uppercase;">
            Why Join This Program
          </h1>
        </div>

        <div style="width:30.245vw;    margin-left: 9vw;margin-top: 3vw;">
          <img src="images/alumni_success/s41.svg" alt="" width="100%" />
        </div>
        <div style="margin-left:10.196vw;margin-top:4.894vw;">
          {#each strategy as data}
            <div style="display: flex;">
              <div style="padding-top: 0.7vw;    width: 2.5vw;text-align: end;">
                <p class="footer-count">{data.count}</p>
              </div>
              <div style="margin-left: 3.5vw;margin-bottom: 1.85vw">
                <p class="footer-text">
                  {@html data.detail}
                </p>
              </div>
            </div>
          {/each}
        </div>
        <div style=" text-align: center;margin-top: 8.135vw;">
          <button
            class="btn-css"
            on:click={() => (location.href = '/applyProgram')}
          >
            Apply Now
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="mobile">
  <div
    style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 29.928vw; margin-bottom: 5vw; "
  >
    <h1
      class="section1"
      style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
    >
      01
    </h1>
    <h1
      class="section-title"
      style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
    >
      Alumni Success Stories
    </h1>
  </div>
  <div>
    <div style="padding: 0vw 8vw;">
      <div style="display: flex;align-items: center;">
        <div style="width: 20vw;">
          <img src="images/alumni_success/Qtum.svg" alt="" width="100%" />
        </div>
        <div style="margin-left: 6.389vw;">
          <p style="font-size: 6.944vw;font-weight:500;color:#00204B;">QTUM</p>
        </div>
      </div>
      <div style="margin-top: 3.972vw;">
        {#if show === 'more...'}
          <p style="font-size: 3.056vw;width: 73.889vw;color:#00204B;">
            110 executives from 56 industries came together for a 5 day program
            to explore the potential for innovation with blockchain technologies
            and chart the future forward.
          </p>
        {:else if show === 'less...'}
          <p style="font-size: 3.056vw;width: 73.889vw;color:#00204B;">
            110 executives from 56 industries came together for a 5 day program
            to explore the potential for innovation with blockchain technologies
            and chart the future forward. Started by a DraperU alum, QTUM and
            Draper University both believe that industries and facets-of-life
            will be disrupted by blockchain technology, in the way that all
            industries and facets-of-life were disrupted by the internet.
          </p>
        {/if}
        <button
          style="border: none; color:#7CC1FF; font-size:5vw;    background-color: transparent;
          margin-left: 65vw;margin-top: -2vw;"
          on:click={() => {
            if (show === 'less...') {
              show = 'more...';
            } else {
              show = 'less...';
            }
          }}>{show}</button
        >
      </div>
    </div>
    <div style="padding: 5vw 8vw;">
      <div style="display: flex;align-items: center;">
        <div style="width: 20vw;">
          <img src="images/alumni_success/algorand.svg" alt="" width="100%" />
        </div>
        <div style="margin-left: 6.389vw;">
          <p
            style="font-size: 6.944vw;font-weight:500;color:#00204B;    line-height: 8.336vw;"
          >
            Algorand Foundation
          </p>
        </div>
      </div>
      <div style="margin-top: 3.972vw;">
        {#if show1 === 'more...'}
          <p style="font-size: 3.056vw;width: 73.889vw;color:#00204B;">
            $17.5M committed on Demo Day. Draper University in partnership with
            the Algorand Foundation and Borderless Capital, sourced, funded and
            accelerated 13 teams building on the Algorand blockchain.
          </p>
        {:else if show1 === 'less...'}
          <p style="font-size: 3.056vw;width: 73.889vw;color:#00204B;">
            $17.5M committed on Demo Day. Draper University in partnership with
            the Algorand Foundation and Borderless Capital, sourced, funded and
            accelerated 13 teams building on the Algorand blockchain. Over 10
            weeks the startups went through rigorous training, met with
            countless mentors, venture capitalists, and leading entrepreneurial
            facilitators while building and growing their Web3 businesses. In
            the end they presented LIVE to over 200 investors from across the
            globe that committed over $17.5M to the presenting teams.
          </p>
        {/if}
        <button
          style="border: none; color:#7CC1FF; font-size:5vw;    background-color: transparent;
          margin-left: 65vw;margin-top: -2vw;"
          on:click={() => {
            if (show1 === 'less...') {
              show1 = 'more...';
            } else {
              show1 = 'less...';
            }
          }}>{show1}</button
        >
      </div>
    </div>
    <div style="padding: 0vw 8vw;">
      <div style="display: flex;align-items: center;">
        <div style="width: 20vw;">
          <img src="/images/alumni_success/tezos.png" alt="" width="100%" />
        </div>
        <div style="margin-left: 6.389vw;    margin-top: 10vw;">
          <p style="font-size: 6.944vw;font-weight:500;color:#00204B;">
            Tezos Israel
          </p>
        </div>
      </div>
      <div style="margin-top: 3.972vw;">
        {#if show2 === 'more...'}
          <p style="font-size: 3.056vw;width: 73.889vw;color:#00204B;">
            80 founders incubated over 2 programs. Tezos Israel and Draper
            University brought together talented advisors and experts from
            Silicon Valley to help mentor, guide and scale blockchain focused
            businesses across the globe.
          </p>
        {:else if show2 === 'less...'}
          <p style="font-size: 3.056vw;width: 73.889vw;color:#00204B;">
            80 founders incubated over 2 programs. Tezos Israel and Draper
            University brought together talented advisors and experts from
            Silicon Valley to help mentor, guide and scale blockchain focused
            businesses across the globe. Excitingly, the potential of blockchain
            remains largely untapped, and the path forward to a more trusting
            and efficient future run on the blockchain is being paved
            minute-by-minute, as we partner with leading blockchains.
          </p>
        {/if}
        <button
          style="border: none; color:#7CC1FF; font-size:5vw;    background-color: transparent;
          margin-left: 65vw;margin-top: -2vw;"
          on:click={() => {
            if (show2 === 'less...') {
              show2 = 'more...';
            } else {
              show2 = 'less...';
            }
          }}>{show2}</button
        >
      </div>
    </div>
  </div>

  <div
    style="display: flex;align-items:center; margin-left:5.556vw;margin-top: -6vw; "
  >
    <h1
      class="section1"
      style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;    margin-top: 3.5vw;"
    >
      02
    </h1>
    <div style="margin-top:16vw;">
      <h1
        class="section-title"
        style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;"
      >
        Speakers Highlights
      </h1>
      <p style="width:72.778vw; font-size:3.889vw; line-height:6.111vw;">
        Pitch to the leading investors and build with the brightest minds in the
        world.
      </p>
    </div>
  </div>
  <div style="margin-top: 5vw;">
    <SpeakerSlider data={speakerSectionBlockchain} />
  </div>
  <!---Curriculum-->
  <div style="width: 80.815vw;margin-left: 11.061vw;">
    <div>
      <h1
        style="color: rgba(124, 193, 255, 0.5);font-size:16.45vw; font-weight: 800;margin-left: 4vw;margin-top:20vw;"
      >
        Become a Hero
      </h1>
    </div>
  </div>
  <div
    style="display: flex;align-items:center; margin-left:1vw; margin-top: -22vw;
    margin-bottom: 5vw;"
  >
    <h1
      class="section1"
      style="color:#00204B;font-size:2.778vw;margin-left:5.556vw; opacity:0.3; margin-top: -3vw;"
    >
      03
    </h1>
    <div>
      <h1
        class="section-title"
        style="color: rgb(0, 32, 75); font-size: 5.556vw; font-weight: 600; text-transform: uppercase; margin-top: 15vw; margin-left: 6.061vw;"
      >
        Curriculum Highlights
      </h1>
      <div style="width:70vw; margin-left: 6.563vw;">
        <p style="font-size:3.056vw; text-align: justify;">
          Applying for entrepreneurship training in Silicon Valley is an easy
          three-step process that we've designed to save time and ensure a
          timely response.
        </p>
      </div>
    </div>
  </div>
  <div class="process-div-mbl">
    <h4
      style="font-size: 5.556vw; font-weight: 600; color: #00204B;width: 64.667vw;"
    >
      Request Customised Program
    </h4>
    <div style="width: 60.833vw;">
      <p style="font-size:3.056vw; color: #00204B;">
        Our application is simple. Tell us your business idea (if you have one),
        and why you were put on this earth. Include what makes you unique!
      </p>
    </div>
    <form on:submit|preventDefault={SaveData} class="process_mbl">
      <input
        required
        class="input-mobile"
        type="text"
        placeholder="Name..."
        bind:value={formData.name}
      />
      <input
        required
        class="input-mobile"
        type="email"
        placeholder="E-mail..."
        bind:value={formData.email}
      />
      <textarea
        required
        bind:value={formData.msg}
        class="textarea_mbl"
        col="20"
        rows="8"
        placeholder="Message"
        style="width: 62.556vw;; border-radius: 2.778vw; padding-left: 4.72vw; padding-top: 1.444vw; margin-top: 2.22vw; 
        background-color: rgb(240, 240, 240); border: 0.5vw solid rgb(121, 173, 244);color: rgb(139 139 139);font-size:3.056vw;"
      />
      <button
        type="submit"
        class="btn-css-mbl"
        style="position: absolute;
        bottom: -4vw;
        left: -19vw;
        font-size: 2.8vw;">Contact Bussiness Develeopment</button
      >
    </form>
  </div>
  <!---For-->
  <div
    style="width: 88.815vw;margin:25vw auto 7vw;padding:0 1vw; height:160vw;"
  >
    <div style="position: relative;    margin-top: 33.55vw;">
      <div style="display:flex;align-items: center;">
        <h1
          style="color:rgba(0, 32, 75, 1);font-size:2.778vw;margin-right:1.5vw;opacity: 0.3;margin-top: 8.7vw;"
        >
          04
        </h1>
        <h1
          style="color: rgba(124, 193, 255, 0.2);font-size: 16.667vw;font-weight: bold;margin-top: -9vw; margin-left: 3vw;"
        >
          For...
        </h1>
      </div>
      <div style="position:absolute;top: 7vw;left: 9vw;">
        <div>
          <h1
            style="font-size:5.556vw; width:75.556vw; color:rgba(75, 154, 215, 1);text-transform: uppercase;"
          >
            Startup
          </h1>
          <div style="width:75vw;">
            <p style="font-size:3.056vw;text-align: justify;">
              Scale with leaders in blockchain acceleration. From Draper's early
              investments in Coinbase and Bitcoin to Boost VC backing Sci-Fi
              startups - We have believed in Web3 technology since day one. Let
              us help you build the right foundation or scale globally.
            </p>
          </div>
        </div>
      </div>
      <div style="position:absolute;top:49vw;left: 9vw;">
        <div>
          <h1
            style="font-size:5.556vw; width:75.556vw;     color: rgb(3, 91, 160);text-transform: uppercase;"
          >
            Major Blockchain
          </h1>
          <div style="width:75vw;">
            <p style="font-size:3.056vw;text-align: justify;">
              We have the right network, infrastructure, and track record to
              deliver a world-class accelerator program, from entrepreneurial
              education and facilities to mentors and venture capital.
            </p>
          </div>
        </div>
      </div>
      <div style="position:absolute;top: 86vw;left: 9vw;">
        <div>
          <h1
            style="font-size:5.556vw; width:75.556vw; color: rgb(3, 91, 160);text-transform: uppercase;"
          >
            Who Else?
          </h1>
          <div style="width:75vw;">
            <p style="font-size:3.056vw;text-align: justify;">
              Meet, network and grow with other blockchain founders building
              products and services on chain. Meet and build relationships with
              world-leading mentors, investors and alumni that support you
              throughout the program.
            </p>
          </div>
          <div
            style="margin-top: 3vw;"
            on:click={() => (location.href = '/applyProgram')}
          >
            <p style="margin: 0;color:#4B9AD7;">Apply Now</p>
            <div style="margin-top: -2.5vw;">
              <img
                src="/images/corporative_section/Line 216.svg"
                alt=""
                width="80vw"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        style="position: absolute;
      top: 80vw;"
      >
        <div
          style="width: 39.444vw;height: 63.889vw;position: absolute;top:60vw;left: 7vw;"
        >
          <img
            src="/images/corporative_section/83514589_2701812689937121_9056403443761020928_n.png"
            alt=""
            width="100%"
          />
        </div>
        <div
          style="    width: 45.222vw;
              position: absolute;
              height: 34.722vw;
              top: 103vw;
              left: 9.2vw;
              z-index: 2;"
        >
          <img
            src="/images/corporative_section/Draper-startuphouse-startuptalky-1.png"
            alt=""
            width="100%"
          />
        </div>
        <div
          style="width: 45.222vw;
          height: 39.722vw;
          position: absolute;
          top: 85vw;
          left: 37vw;
          z-index: 2;"
        >
          <img
            src="/images/corporative_section/image-asset 2.png"
            alt=""
            width="100%"
          />
        </div>
      </div>
    </div>
  </div>
  <div style="position: relative;
  margin-top: 89vw; 
  z-index:1;">
    <div class="top_mbl">
      <div class="hr_mbl" />
      <div class="hr1_mbl" />
      <h6
        style="color: white; font-size:5.556vw; font-weight:600;margin-top: 4.5vw;text-transform: uppercase;"
      >
        Fast-tracking your global <br /> innovation strategy
      </h6>
    </div>
  </div>
  <div
    style="background: linear-gradient(1.05deg, #00204B 50.19%, #00429B 99.35%);padding:1vw; position: relative;
      margin-top: 125vw;margin-bottom: -0.8vw;"
  >
    <div style="width: 88.815vw;margin:7vw auto 0vw;padding:0 1vw;">
      <div style="display: flex;align-items:center">
        <h1
          style="color:white;font-size:2.778vw;margin-right:7.061vw; opacity: 0.7;"
        >
          05
        </h1>
        <h1
          style="color:white;font-size: 5.556vw; font-weight: 600;text-transform: uppercase;"
        >
          Why Join This Program
        </h1>
      </div>

      <div style="width:76.667vw ;margin: auto; margin-top: 6vw;">
        <img src="images/alumni_success/s41.svg" alt="" width="100%" />
      </div>
      <div style="  margin-top: 15.839vw;">
        {#each strategy as data}
          <div style="display: flex;justify-content: center;">
            <div style=" width:8vw; text-align: end;">
              <p class="footer-count">{data.count}</p>
            </div>
            <div style="margin-left: 7.808vw;">
              <p class="footer-text">
                {data.detail}
              </p>
            </div>
          </div>
        {/each}
      </div>
      <div style="text-align: center;margin-top: 15.633vw;">
        <button
          class="btn-css-mbl"
          style="background-color:#f7e05f;color:black;margin-left:0vw;width:40.012vw;"
          on:click={() => (location.href = '/applyProgram')}>Apply</button
        >
      </div>
    </div>
  </div>
</div>
<Footer />

<style>
  .footer-count {
    font-weight: bold;
    font-size: 1.7vw;
    font-family: "inter";
    color: #88bce5;
  }
  .footer-text {
    font-size: 1.653vw;
    font-weight: 500;
    font-family: "inter";
    width: 62.765vw;
    margin-top: 1vw;
    color: white;
    line-height: 1.95vw;
  }
  .circle {
    height: 16.204vw;
    width: 16.204vw;
    border-radius: 50%;
    opacity: 40%;
    position: absolute;
    left: 23vw;
    background-color: rgba(60, 136, 195, 0.33);
    justify-content: center;
  }
  .circle:nth-child(2) {
    top: 12vw;
  }
  .circle:nth-child(3) {
    top: 24vw;
  }
  p {
    margin-bottom: 0vw;
  }
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
  @media screen and (max-width: 1024px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    li::marker {
      font-size: 4.2vw !important;
    }
    .textarea_mbl::placeholder {
      font-size: 3.056vw;
    }
    .footer-count {
      font-weight: bold;
      font-size: 5.556vw;
      font-family: "inter";
      color: #88bce5;
    }
    .footer-text {
      font-size: 3.056vw;
      font-weight: 500;
      font-family: "inter";
      width: 69vw;
      margin-top: 1vw;
      line-height: 5.556vw;
      color: white;
      margin-bottom: 9.009vw;
    }
  }
  .speaker_box {
    width: 16.667vw;
    height: 17.394vw;
    border: 0.198vw solid #7cc1ff;
    border-right: none;
    border-bottom: none;
    position: relative;
  }
  .speaker_box:nth-child(6) {
    border-right: 0.198vw solid #7cc1ff;
  }
  .speaker_box:nth-child(9) {
    border-right: 0.198vw solid #7cc1ff;
    border-bottom: 0.198vw solid #7cc1ff;
    border-bottom-right-radius: 1vw;
  }
  .speaker_box:nth-child(3) {
    border-right: 0.198vw solid #7cc1ff;
    border-top-right-radius: 1vw;
  }
  .speaker_box:nth-child(1) {
    border-top-left-radius: 1vw;
  }
  .speaker_box:nth-child(8) {
    border-bottom: 0.198vw solid #7cc1ff;
  }
  .speaker_box:nth-child(7) {
    border-bottom: 0.198vw solid #7cc1ff;
    border-bottom-left-radius: 1vw;
  }
  .speaker_box::after {
    content: "";
    height: 1.19vw;
    width: 1.19vw;
    background: #f7e05f;
    position: absolute;
    bottom: -0.6vw;
    z-index: 1;
    border-radius: 5vw;
    left: -0.3vw;
  }
  .speaker {
    display: flex;
    position: relative;
  }
  .text {
    overflow: hidden;
    height: 100%;
    border-bottom-right-radius: 0.7vw;
    border-bottom-left-radius: 0.7vw;
  }
  .hr {
    width: 0.397vw;
    position: absolute;
    height: 6.742vw;
    left: 21.214vw;
    top: -5vw;
    background-color: #f7e05f;
    border-radius: 0.397vw;
    z-index: +20;
  }
  .hr1 {
    width: 0.397vw;
    position: absolute;
    height: 2vw;
    left: 12.2vw;
    top: 9vw;
    background-color: #f7e05f;
    transform: rotate(90deg);
    border-radius: 0.397vw;
    z-index: +2;
  }
  .hr_mbl {
    width: 1vw;
    position: absolute;
    height: 43.689vw;
    left: 25.214vw;
    top: -36.5vw;
    background-color: #f7e05f;
    border-radius: 0.397vw;
  }
  .hr1_mbl {
    width: 6.389vw;
    position: absolute;
    height: 1vw;
    left: 20.5vw;
    top: 30vw;
    background-color: #f7e05f;
    transform: rotate(180deg);
    border-radius: 0.397vw;
    z-index: +2;
  }
  .top {
    position: absolute;
    width: 100%;
    height: 12.831vw;
    background: #7cc1ff;
    text-align: center;
  }
  .top_mbl {
    padding: 8vw 0vw;
    position: absolute;
    width: 100vw;
    background: #7cc1ff;
    text-align: center;
  }
  li::marker {
    font-size: 1.2vw;
    color: #88bce5;
    font-weight: 900;
  }
  .back-div {
    width: 42.13vw;
    height: 41.667vw;
    background: linear-gradient(155.25deg, #9ec7ff 1.68%, #064cab 84.22%);
    border-radius: 3vw 3vw 1.5vw 1.5vw;
    margin-left: 10vw;
  }
  .process-div {
    position: absolute;
    width: 37.103vw;
    height: 39.815vw;
    background-color: white;
    padding-left: 4.828vw;
    padding-top: 2.704vw;
    top: 3.108vw;
    left: 2.513vw;
    border-radius: 3vw 3vw 0vw 0vw;
  }
  .process-div-mbl {
    width: 76.111vw;
    position: relative;
    padding: 9vw 9vw;
    background-color: white;
    border-radius: 7vw 7vw 0vw 0vw;
    box-shadow: 0px -9px 20px rgb(60 116 192 / 20%);
    margin: auto;
    margin-top: 10vw;
  }
  .btn-css-mbl {
    background-color: #3c74c0;
    border-radius: 8.333vw;
    color: white;
    font-weight: 500;
    border: none;
    width: 55.579vw;
    height: 10.561vw;
    font-size: 3.056vw;
    margin-left: 31vw;
  }
  .input-mobile {
    width: 62.556vw;
    padding-left: 4.722vw;
    margin-top: 2.22vw;
    height: 10.056vw;
    font-size: 3.056vw;
    border-radius: 2.778vw;
    border: 0.5vw solid rgba(121, 173, 244, 1);
    background-color: #f0f0f0;
  }
  .input-mobile::placeholder {
    font-size: 3.056vw;
  }
  .input_desktop {
    width: 27.447vw;
    padding-left: 1vw;
    font-size: 0.926vw;
    height: 3.902vw;
    border-radius: 0.661vw;
    border: 0.066vw solid rgba(121, 173, 244, 1);
    background-color: #f0f0f0;
  }
  .input_desktop::placeholder {
    font-size: 0.926vw;
  }
  .textarea::placeholder {
    font-size: 0.926vw;
  }
  .btn-css {
    background-color: #f7e05f;
    border-radius: 1.984vw;
    color: #00204b;
    font-weight: 500;
    border: none;
    width: 13.228vw;
    height: 3.2vw;
    font-size: 1.19vw;
  }
  .btn-css:hover {
    background-color: transparent;
    border: 0.194vw solid white;
    color: white;
    width: 13.228vw;
    height: 3.2vw;
    font-weight: 500;
    font-size: 1.19vw;
  }
</style>
